export default
    {
        // url: this.$store.state.http.consulta.YYYY,
        cancelaDia: "/consulta/cancelaDia",
        eventos: "/consulta/eventsV2",
        getCita: "/consulta/getCita",
        guardaCita: "/consulta/guardaCitaSf",
        listCita: "/consulta/listCitaSf",
        listMedicos: "/consulta/listMedicos",
    }
